import { Stack, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import ExpandableUpdateSubmissionStatusTasks from './ExpandableUpdateSubmissionStatusTasks'
import ExpandableUpdateSubmissionStatusTimepoint from './ExpandableUpdateSubmissionStatusTimepoint'
import ExpandableUpdateSubmissionStatusExam from './ExpandableUpdateSubmissionStatusExam'
import { useFormContext } from 'react-hook-form'
import { ExamReassignementFormValues } from '../../schemas/ExamReassignementEsignValidationSchema'

export default function UpdateSubmissionStatus({
  currentTimepointSubmissionId,
  isExpandable = true,
}: {
  currentTimepointSubmissionId?: string
  isExpandable?: boolean
}) {
  const { subjectId } = useParams<{
    subjectId: string
  }>()

  const { watch, setValue } = useFormContext<ExamReassignementFormValues>()

  // Watch form values
  const selectedTimepointSubmissionId = watch('to_timepoint_submission.timepoint_submission_id')
  const selectedSubjectId = watch('selected_subject_id')
  const selectedExams = watch('exam_metadata_ids')
  const fromTimepointStatus = watch('from_timepoint_submission.new_status')
  const toTimepointStatus = watch('to_timepoint_submission.new_status')

  // Set status handlers
  const setFromTimepointStatus = (status: string) => {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    setValue('from_timepoint_submission.new_status', status as any, { shouldValidate: true })
  }

  const setToTimepointStatus = (status: string) => {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    setValue('to_timepoint_submission.new_status', status as any, { shouldValidate: true })
  }

  return (
    <>
      <Stack spacing={4} width={840}>
        <Typography color="text.primary" variant="h4">
          Update submission status
        </Typography>
        <Stack spacing={3}>
          <ExpandableUpdateSubmissionStatusExam selectedExams={new Set(selectedExams)} isExpandable={isExpandable} />
          <ExpandableUpdateSubmissionStatusTimepoint
            selectedTimepointSubmissionId={selectedTimepointSubmissionId}
            selectedSubjectId={selectedSubjectId!}
            isExpandable={isExpandable}
          />
          <ExpandableUpdateSubmissionStatusTasks
            timepointSubmissionId={currentTimepointSubmissionId}
            subjectId={subjectId}
            selectedStatus={fromTimepointStatus || ''}
            setSelectedStatus={setFromTimepointStatus}
            isCurrent
            isExpandable={isExpandable}
          />
          <ExpandableUpdateSubmissionStatusTasks
            timepointSubmissionId={selectedTimepointSubmissionId}
            selectedStatus={toTimepointStatus || ''}
            subjectId={selectedSubjectId}
            setSelectedStatus={setToTimepointStatus}
            isExpandable={isExpandable}
          />
        </Stack>
      </Stack>
    </>
  )
}
